import linkifyHtml from 'linkify-html'

export const capitalize = (str = '') => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const shorten = (str, maxLength) => {
  if (!str) return ''

  if (str.length < maxLength) return str

  return str.substring(0, maxLength + 3).replace(/...$/, '...')
}

export const caretReplace = (content) => {
  return content.replace(/\r/g, '<br/>')
}

export const linkify = (content, length = 30) => {
  const options = {
    attributes: null,
    className: 'b-list__link',
    defaultProtocol: 'http',
    events: null,
    format: (value) => {
      return value.length > length ? value.slice(0, length) + '…' : value
    },
    formatHref: (href) => {
      return href
    },
    nl2br: true,
    tagName: 'a',
    target: {
      url: '_blank',
    },
  }

  return linkifyHtml(content, options)
}

export const formatSuffix = (number) => {
  let suffix = ''

  switch (number % 10) {
    case 1:
      suffix = number % 100 === 11 ? 'th' : 'st'
      break
    case 2:
      suffix = number % 100 === 12 ? 'th' : 'nd'
      break
    case 3:
      suffix = number % 100 === 13 ? 'th' : 'rd'
      break
    default:
      suffix = 'th'
      break
  }
  return number + suffix
}

export const slugify = (text) => {
  const specialChars = 'áàãäâéèẽëêíìïîóòõöôúùüûñç·/_,:;'
  const substitutes = 'aaaaaeeeeeiiiiooooouuuunc------'
  const specialCharsRegExp = new RegExp(specialChars.split('').join('|'), 'g')

  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(specialCharsRegExp, (character) => substitutes.charAt(specialChars.indexOf(character)))
    .replace(/[^\w\-]+/g, '')
    .replace(/^-+/, '')
    .replace(/-+$/, '')
}
